import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'imc-sync',
});

/**
 * Detail page listing the Components (GitLab projects) of a single System
 * (GitLab group), where the user selects which ones to sync.
 */
export const systemRouteRef = createSubRouteRef({
  id: 'imc-sync/system',
  parent: rootRouteRef,
  path: '/systems/:namespace/:name',
});
